import { render, staticRenderFns } from "./SintomasOtros2.vue?vue&type=template&id=0aefb2b3"
import script from "./SintomasOtros2.vue?vue&type=script&lang=js"
export * from "./SintomasOtros2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports